<template>
  <div class="zee zee-component">
    <!-- 查看/禁用模式：纯图片展示 -->
    <a-image v-if="disabled && imageUrl"
             width="80" height="80"
             :src="imageUrl"
             fit="cover"
             style="border-radius: 8px; cursor: pointer;"
    />
    <span v-else-if="disabled && !imageUrl" style="color:#c0c4cc;">暂无</span>

    <!-- 编辑/新增模式：上传组件 -->
    <a-upload v-else-if="name"
              :action="upUrl"
              :headers="headers"
              :file-list="fileList"
              list-type="picture-card"
              :limit="1"
              :before-upload="beforeUpload"
              @change="bindFileUpload"
              @error="handleUploadError">
      <template #default>
        <div v-if="!fileList.length">
          <icon-plus />
          <div>上传</div>
        </div>
      </template>
    </a-upload>
    <div v-if="uploadError && !disabled" class="upload-error-message">
      <a-alert message="上传失败" description="文件过大或服务器错误，请重试" type="error" />
    </div>
  </div>
</template>

<script>
const env = require("../../../env/index");
import { IconPlus } from '@arco-design/web-vue/es/icon'

export default {
  name: "FUploadImage",
  components: { IconPlus },
  props: {
    name: String,
    value: [String, Array],
    disabled: Boolean,
    maxFileSize: { type: Number, default: 5 }
  },
  computed: {
    imageUrl() {
      if (!this.value) return ''
      const v = this.value
      if (typeof v === 'string') {
        if (v.startsWith('http')) return v
        try {
          const p = JSON.parse(v)
          return p.url || p[0]?.url || ''
        } catch { return '' }
      }
      return v.url || ''
    }
  },
  data() {
    return {
      upUrl: env.UPLOAD,
      headers: { token: JSON.stringify(Object.assign(env.TOKEN, { token: this.$fan?.getToken() || '' })) },
      fileList: [],
      uploadError: false,
      isUploading: false
    };
  },
  watch: {
    value(newValue) { this.fileList = this.initFileList(newValue); },
  },
  created() {
    let val = this.value
    if (typeof val === 'string' && (val.startsWith('[') || val.startsWith('{'))) {
      try { const p = JSON.parse(val); val = p.url || p[0]?.url || val } catch {}
    }
    this.fileList = this.initFileList(val);
  },
  methods: {
    initFileList(value) {
      if (typeof value === 'string' && value.trim()) {
        return [{ uid: '-1', name: value.split('/').pop() || '图片', url: value, status: "done" }];
      }
      return [];
    },
    beforeUpload(file) {
      const fileSize = file.size / 1024 / 1024;
      if (fileSize > this.maxFileSize) {
        this.$message.error(`文件大小超过限制（最大${this.maxFileSize}MB）`);
        return false;
      }
      this.uploadError = false;
      this.isUploading = true;
      return true;
    },
      bindFileUpload(info, file) {
        this.fileList = info.fileList;
        const fileItem = file || info.file;
        if (fileItem.status === "removed") {
          this.uploadError = false;
          this.$emit("change", this.name, "");
        } else if (fileItem.status === "done" && fileItem.response && fileItem.response.data) {
          this.isUploading = false;
          this.$emit("change", this.name, fileItem.response.data);
        } else if (fileItem.status === "error") {
          this.isUploading = false;
          this.uploadError = true;
          this.$message.error('上传失败，请检查网络或文件');
        }
      },
    handleUploadError(err) {
      this.isUploading = false;
      this.uploadError = true;
      this.$message.error(`上传失败: ${err.message || '未知错误'}`);
      this.fileList = this.fileList.map(item => {
        if (item.uid === err.uid) return { ...item, status: 'error' };
        return item;
      });
    }
  },
};
</script>

<style scoped>
.upload-error-message { margin-top: 10px; }
</style>
